import { useEffect } from 'react';

// Mirror env(safe-area-inset-*) into --fielder-safe-top/-bottom, because some
// WebKit contexts report 0 on first layout and only settle later.
export default function useSafeAreaVars() {
  useEffect(() => {
    const probe = document.createElement('div');
    probe.style.cssText =
      'position:fixed;top:0;left:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
      'padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px);';
    document.body.appendChild(probe);

    let rafId = 0;
    let lastTop = -1;
    let lastBottom = -1;

    const apply = () => {
      rafId = 0;
      const cs = getComputedStyle(probe);
      const top = parseFloat(cs.paddingTop) || 0;
      const bottom = parseFloat(cs.paddingBottom) || 0;
      if (top === lastTop && bottom === lastBottom) return;
      lastTop = top;
      lastBottom = bottom;
      const root = document.documentElement.style;
      // Only pin a real inset; a 0 leaves the CSS env() fallback live so a late
      // engine correction still lands.
      if (top > 0) root.setProperty('--fielder-safe-top', `${top}px`);
      else root.removeProperty('--fielder-safe-top');
      if (bottom > 0) root.setProperty('--fielder-safe-bottom', `${bottom}px`);
      else root.removeProperty('--fielder-safe-bottom');
    };

    const schedule = () => {
      if (!rafId) rafId = requestAnimationFrame(apply);
    };

    apply();
    const raf = requestAnimationFrame(apply);
    const settle = setTimeout(apply, 300);
    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);

    return () => {
      cancelAnimationFrame(raf);
      if (rafId) cancelAnimationFrame(rafId);
      clearTimeout(settle);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('orientationchange', schedule);
      probe.remove();
    };
  }, []);
}
